/** Money crosses the API as an integer number of haléře (migration
 *  20260806120000); koruny are what the partner types and what the domain
 *  carries, so the two units meet here and nowhere else. Rounding is half up,
 *  which parts from that migration's half-away-from-zero rule only on negative
 *  amounts — and the column refuses those. */
export function toMinorUnits(korun: number | null): number | null {
  return korun === null ? null : Math.round(korun * 100);
}

export function fromMinorUnits(haler: number | null): number | null {
  return haler === null ? null : haler / 100;
}
